import { createReducer } from 'services/reduxHelpers'
import { cityTypes } from 'reduxModules/actions/CityActions'
import { routeTypes } from 'reduxModules/actions/RouteActions'

/* ------------- Initial State ------------- */

export const initialState = {
  allCities: [],
  routeCities: [],
  returnRouteCities: [],
  isLoading: false,
}

/* ------------- Hookup Reducers To Types ------------- */

const disabledCityAttempt = ({ routeCities }, { data: { id, checked } }) => ({
  routeCities: routeCities.map(city => {
    if (city.id === id) {
      return {
        ...city,
        disabled: checked
      }
    }

    return city
  })
})

const disabledCityFailure = ({ routeCities }, { data: { id, checked } }) => ({
  routeCities: routeCities.map(city => {
    if (city.id === id) {
      return {
        ...city,
        disabled: !checked
      }
    }

    return city
  })
})

const updateCityStationAttempt = ({ allCities }, { data: { id, value } }) => ({
  allCities: allCities.map(city => {
    if (city.id === id) {
      return {
        ...city,
        station: value
      }
    }

    return city
  }),
})

const updateCityTimeAttempt = ({ returnRouteCities, routeCities }, { data: { id, returnTime, name, value } }) => {
  if (returnTime) {
    return {
      returnRouteCities: returnRouteCities.map(city => {
        if (city.id === id) {
          return {
            ...city,
            [name]: value
          }
        }

        return city
      })
    }
  } else {
    return {
      routeCities: routeCities.map(city => {
        if (city.id === id) {
          return {
            ...city,
            [name]: value
          }
        }

        return city
      })
    }
  }
}

export default createReducer(initialState, {
  [cityTypes.GET_ALL_CITIES_SUCCESS]: (_, { data }) => ({
    allCities: data
  }),

  [cityTypes.GET_ROUTE_CITIES_ATTEMPT]: () => ({
    isLoading: true
  }),
  [cityTypes.GET_ROUTE_CITIES_SUCCESS]: (_, { data: { routeCities, returnRouteCities } }) => ({
    routeCities,
    returnRouteCities,
    isLoading: false
  }),
  [cityTypes.GET_ROUTE_CITIES_FAILURE]: () => ({
    isLoading: false
  }),

  [routeTypes.SUBSCRIBE_INFO_ATTEMPT]: () => ({
    isLoading: true
  }),
  [routeTypes.SUBSCRIBE_INFO_SUCCESS]: () => ({
    isLoading: false
  }),
  [routeTypes.SUBSCRIBE_INFO_FAILURE]: () => ({
    isLoading: false
  }),

  [cityTypes.CLEAR_ROUTE_CITIES_ATTEMPT]: () => ({
    routeCities: [],
    returnRouteCities: []
  }),

  [cityTypes.UPDATE_CITY_STATION_ATTEMPT]: updateCityStationAttempt,

  [cityTypes.UPDATE_CITY_TIME_ATTEMPT]: updateCityTimeAttempt,

  [cityTypes.DISABLE_CITY_ATTEMPT]: disabledCityAttempt,
  [cityTypes.DISABLE_CITY_FAILURE]: disabledCityFailure
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/CityReducer.js